import { DesktopIcon, EWidgetRegion, TabletIcon, ViewWallIcon } from '#shared';

import type { ToolbarDevice } from './types';

export const PREVIEW_DEVICES: ToolbarDevice[] = [
  {
    id: 1,
    Icon: ViewWallIcon,
    title: 'View Wall (4K)',
    regions: [EWidgetRegion.Left, EWidgetRegion.Center, EWidgetRegion.Right],
  },
  {
    id: 2,
    Icon: DesktopIcon,
    title: 'Large Desktop (1920+)',
    regions: [EWidgetRegion.Left, EWidgetRegion.Center],
  },
  {
    id: 3,
    Icon: TabletIcon,
    title: 'Desktop/Tablet (1024-1920)',
    regions: [EWidgetRegion.Center],
  },
];

export const PREVIEW_STYLE_SLOTS = {
  region: {
    root: {
      fontSize: '10px',
      height: '100%',
      width: '100%',
    },
    label: {
      display: 'none',
    },
    body: {
      height: '100%',
    },
  },
  section: {
    root: {
      height: '100%',
    },
    body: {
      height: '100%',
    },
  },
} as const;
